import { render, staticRenderFns } from "./confirmFormFromEmail.vue?vue&type=template&id=b186845e&scoped=true&"
import script from "./confirmFormFromEmail.vue?vue&type=script&lang=js&"
export * from "./confirmFormFromEmail.vue?vue&type=script&lang=js&"
import style0 from "./confirmFormFromEmail.vue?vue&type=style&index=0&id=b186845e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b186845e",
  null
  
)

export default component.exports